/* eslint-disable */
import { useEffect, useState, useContext } from 'react';
import { Dialog, Select, MenuItem, DialogContent } from '@mui/material';
import TableComponent from './tableComponent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import styles from './sdlc.module.scss';
import PropTypes from 'prop-types';
import {
  addTaskData,
  deleteTaskData,
  editTaskData,
  getTaskData,
  addProjectManagementData,
  deleteProjectManagementData,
  editProjectManagementData,
  getProjectManagementData,
  addCodeCoverageData,
  deleteCodeCoverageData,
  editCodeCoverageData,
  getCodeCoverageData,
  addTestData,
  deleteTestData,
  editTestData,
  getTestData,
} from '../../../Api/request/sdlc';
import UseAxios from '../../../Api/http/http';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';

const taskHeaders = [
  { key: 'task', label: 'Task' },
  { key: 'percentage', label: '%' },
  { key: 'percentage_of', label: '% of' },
  { key: 'remarks', label: 'Remarks' },
];

const projectHeaders = [
  { key: 'from', label: 'From Effort' },
  { key: 'to', label: 'To Effort' },
  { key: 'percentage', label: 'PM Effort %' },
  { key: 'percentage_of', label: '% of' },
  { key: 'remarks', label: 'Remarks' },
];

const codeCoverageHeaders = [
  { key: 'from', label: 'From Effort' },
  { key: 'to', label: 'To Effort' },
  { key: 'percentage', label: '%' },
  { key: 'percentage_of', label: '% of' },
  { key: 'remarks', label: 'Remarks' },
];

const testHeaders = [
  { key: 'type', label: 'Task' },
  { key: 'is_mandatory', label: 'Effort' },
  { key: 'percentage', label: '%' },
  { key: 'percentage_of', label: '% of' },
  { key: 'remarks', label: 'Remarks' },
];

const resourceTypes = [
  { label: 'Total Dev', value: 'TOTALDEV' },
  { label: 'Total Project Per Week', value: 'TOTALPROJECT' },
  { label: 'FE Dev', value: 'FEDEV' },
  { label: 'BE Dev', value: 'BEDEV' },
];

const Sdlc = () => {
  const [taskData, setTaskData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [codeCoverageData, setCodeCoverageData] = useState([]);
  const [testData, setTestData] = useState([]);
  const { userProfile } = useContext(AuthContext);

  const [openDialog, setOpenDialog] = useState(false);
  const [currentTable, setCurrentTable] = useState(null);
  const [newRow, setNewRow] = useState({});
  const [editIndex, setEditIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_EFFORTS] || []
    : [];

  const hasAccess = (action) => permission.includes(action);

  useEffect(() => {
    const fetchTaskData = async () => {
      try {
        const res = await UseAxios(getTaskData());
        setTaskData(res.data.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchProjectManagementData = async () => {
      try {
        const res = await UseAxios(getProjectManagementData());
        setProjectData(res.data.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchCodeCoverageData = async () => {
      try {
        const res = await UseAxios(getCodeCoverageData());
        setCodeCoverageData(res.data.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    const fetchTestData = async () => {
      try {
        const res = await UseAxios(getTestData());
        setTestData(res.data.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchTestData();

    fetchCodeCoverageData();

    fetchTaskData();

    fetchProjectManagementData();
  }, []);

  const handleDialogOpen = (tableId, rowId = null) => {
    setCurrentTable(tableId);
    setEditIndex(rowId);
    const tableData = {
      taskTable: taskData,
      projectTable: projectData,
      codeCoverageTable: codeCoverageData,
      testTable: testData,
    };
    setNewRow(
      rowId !== null
        ? tableData[tableId]?.find((row) => row.id === rowId) || {}
        : {}
    );

    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setErrorMessage('');
    setOpenDialog(false);
  };

  const handleAddRow = () => {
    const requiredFields = {
      taskTable: ['task', 'percentage', 'percentage_of', 'remarks'],
      projectTable: ['from', 'to', 'percentage', 'percentage_of', 'remarks'],
      codeCoverageTable: [
        'from',
        'to',
        'percentage',
        'percentage_of',
        'remarks',
      ],
      testTable: [
        'type',
        'is_mandatory',
        'percentage',
        'percentage_of',
        'remarks',
      ],
    };

    const currentRequiredFields = requiredFields[currentTable] || [];

    const allFieldsFilled = currentRequiredFields.every((field) => {
      if (field === 'is_mandatory') {
        return newRow[field] !== null && newRow[field] !== undefined;
      }
      return (
        newRow[field] &&
        (typeof newRow[field] === 'string' ? newRow[field].trim() !== '' : true)
      );
    });

    if (!allFieldsFilled) {
      setErrorMessage('All fields must be filled');
      return;
    }

    const tableConfigs = {
      taskTable: { addApi: addTaskData, setData: setTaskData, data: taskData },
      projectTable: {
        addApi: addProjectManagementData,
        setData: setProjectData,
        data: projectData,
      },
      codeCoverageTable: {
        addApi: addCodeCoverageData,
        setData: setCodeCoverageData,
        data: codeCoverageData,
      },
      testTable: { addApi: addTestData, setData: setTestData, data: testData },
    };

    const currentConfig = tableConfigs[currentTable];

    if (!currentConfig) return;

    if (editIndex !== null) {
      editData(currentTable, newRow);
    } else {
      const addData = async () => {
        try {
          const res = await UseAxios(currentConfig.addApi(newRow));
          currentConfig.setData([...currentConfig.data, res.data.data]);
        } catch (err) {
          console.error('Error fetching data:', err);
        }
      };
      addData();
    }

    handleDialogClose();
  };

  const handleInputChange = (field, value) => {
    setNewRow({ ...newRow, [field]: value });
  };
  const editData = async (tableId, editedRow) => {
    try {
      if (tableId === 'taskTable') {
        const res = await UseAxios(editTaskData(editedRow));
        const resData = res.data.data.data;

        resData &&
          setTaskData((prevData) =>
            prevData.map((item) => (item.id === resData.id ? resData : item))
          );
      } else if (tableId === 'projectTable') {
        const res = await UseAxios(editProjectManagementData(editedRow));
        const resData = res.data.data.data;

        resData &&
          setProjectData((prevData) =>
            prevData.map((item) => (item.id === resData.id ? resData : item))
          );
      } else if (tableId === 'codeCoverageTable') {
        const res = await UseAxios(editCodeCoverageData(editedRow));
        const resData = res.data.data.data;

        resData &&
          setCodeCoverageData((prevData) =>
            prevData.map((item) => (item.id === resData.id ? resData : item))
          );
      } else if (tableId === 'testTable') {
        const res = await UseAxios(editTestData(editedRow));
        const resData = res.data.data.data;

        resData &&
          setTestData((prevData) =>
            prevData.map((item) => (item.id === resData.id ? resData : item))
          );
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const handleDeleteRow = (tableId, id) => {
    const tableData = {
      taskTable: taskData,
      projectTable: projectData,
      codeCoverageTable: codeCoverageData,
      testTable: testData,
    };

    const selectedRowId = tableData[tableId]?.find((row) => row.id === id)?.id;

    const deleteRow = async (editedRowId) => {
      const token = localStorage.getItem('authToken');

      try {
        if (tableId === 'taskTable') {
          const res = await UseAxios(deleteTaskData(editedRowId, token));
          if (res.data.status === 200) {
            const updatedRes = await UseAxios(getTaskData());
            setTaskData(updatedRes.data.data);
          }
        } else if (tableId === 'projectTable') {
          const res = await UseAxios(
            deleteProjectManagementData(editedRowId, token)
          );
          if (res.data.status === 200) {
            const updatedRes = await UseAxios(getProjectManagementData());
            setProjectData(updatedRes.data.data);
          }
        } else if (tableId === 'codeCoverageTable') {
          const res = await UseAxios(
            deleteCodeCoverageData(editedRowId, token)
          );
          if (res.data.status === 200) {
            const updatedRes = await UseAxios(getCodeCoverageData());
            setCodeCoverageData(updatedRes.data.data);
          }
        } else if (tableId === 'testTable') {
          const res = await UseAxios(deleteTestData(editedRowId, token));
          if (res.data.status === 200) {
            const updatedRes = await UseAxios(getTestData());
            setTestData(updatedRes.data.data);
          }
        }
      } catch (err) {
        console.error('Error handling delete operation:', err);
      }
    };

    if (selectedRowId) {
      deleteRow(selectedRowId);
    } else {
      console.error('Invalid row index or table ID');
    }
  };

  const getHeaderTitle = (currentTable) => {
    const tableHeaders = {
      taskTable: 'Task Management',
      projectTable: 'Project Management',
      codeCoverageTable: 'Code Coverage',
      testTable: 'QA Efforts',
    };

    return tableHeaders[currentTable] || '';
  };

  return (
    <div className={styles.container}>
      <Accordion
        className={styles.accordion}
      >
        <AccordionSummary
          aria-controls={`deal-content`}
          id={`deal-header`}
          className={styles['accordion-header']}
          sx={{
            '&.Mui-expanded .accordion-icon': {
              transform: 'rotate(180deg)',
              transition: 'transform 0.3s ease',
            },
          }}
        >
          <ExpandMoreIcon
            className="accordion-icon"
            sx={{ marginRight: '8px' }}
          />
          <div className={styles['accordion-header']}>Task management</div>
        </AccordionSummary>
        <AccordionDetails className={styles['accordion-details']}>
          <TableComponent
            headers={taskHeaders}
            data={taskData}
            onDeleteRow={(id) => handleDeleteRow('taskTable', id)}
            onEditRow={(id) => handleDialogOpen('taskTable', id)}
            openAddRowDialog={() => handleDialogOpen('taskTable')}
            rowType="taskTable"
            hasAccess={hasAccess}
          />
        </AccordionDetails>
      </Accordion>

      {/* Project Management */}

      <Accordion
        className={styles.accordion}
      >
        <AccordionSummary
          aria-controls={`deal-content`}
          id={`deal-header`}
          className={styles['accordion-header']}
          sx={{
            '&.Mui-expanded .accordion-icon': {
              transform: 'rotate(180deg)',
              transition: 'transform 0.3s ease',
            },
          }}
        >
          <ExpandMoreIcon
            className="accordion-icon"
            sx={{ marginRight: '8px' }}
          />

          <div className={styles['accordion-header']}>Project management</div>
        </AccordionSummary>
        <AccordionDetails className={styles['accordion-details']}>
          <TableComponent
            headers={projectHeaders}
            data={projectData}
            onDeleteRow={(id) => handleDeleteRow('projectTable', id)}
            onEditRow={(id) => handleDialogOpen('projectTable', id)}
            openAddRowDialog={() => handleDialogOpen('projectTable')}
            rowType="projectTable"
            hasAccess={hasAccess}
          />
        </AccordionDetails>
      </Accordion>

      {/* Code Coverage */}

      <Accordion
        className={styles.accordion}
      >
        <AccordionSummary
          aria-controls={`deal-content`}
          id={`deal-header`}
          className={styles['accordion-header']}
          sx={{
            '&.Mui-expanded .accordion-icon': {
              transform: 'rotate(180deg)',
              transition: 'transform 0.3s ease',
            },
          }}
        >
          <ExpandMoreIcon
            className="accordion-icon"
            sx={{ marginRight: '8px' }}
          />

          <div className={styles['accordion-header']}>Code Coverage</div>
        </AccordionSummary>
        <AccordionDetails className={styles['accordion-details']}>
          <TableComponent
            headers={codeCoverageHeaders}
            data={codeCoverageData}
            onDeleteRow={(id) => handleDeleteRow('codeCoverageTable', id)}
            onEditRow={(id) => handleDialogOpen('codeCoverageTable', id)}
            openAddRowDialog={() => handleDialogOpen('codeCoverageTable')}
            rowType="codeCoverageTable"
            hasAccess={hasAccess}
          />
        </AccordionDetails>
      </Accordion>

      {/* QA Efforts */}

      <Accordion
        className={styles.accordion}
      >
        <AccordionSummary
          aria-controls={`deal-content`}
          id={`deal-header`}
          className={styles['accordion-header']}
          sx={{
            '&.Mui-expanded .accordion-icon': {
              transform: 'rotate(180deg)',
              transition: 'transform 0.3s ease',
            },
          }}
        >
          <ExpandMoreIcon
            className="accordion-icon"
            sx={{ marginRight: '8px' }}
          />

          <div className={styles['accordion-header']}>QA Efforts</div>
        </AccordionSummary>
        <AccordionDetails className={styles['accordion-details']}>
          <TableComponent
            headers={testHeaders}
            data={testData}
            onDeleteRow={(id) => handleDeleteRow('testTable', id)}
            onEditRow={(id) => handleDialogOpen('testTable', id)}
            openAddRowDialog={() => handleDialogOpen('testTable')}
            rowType="testTable"
            hasAccess={hasAccess}
          />
        </AccordionDetails>
      </Accordion>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <header className={styles['dialog-header']}>
          {getHeaderTitle(currentTable)}
        </header>
        <DialogContent className={styles['dialog-content']}>
          <DialogForm
            table={currentTable}
            newRow={newRow}
            handleInputChange={handleInputChange}
            resourceTypes={resourceTypes}
          />
          {errorMessage && (
            <div className={styles['error-message']}>{errorMessage}</div>
          )}
        </DialogContent>
        <footer className={styles['dialog-footer']}>
          <button
            onClick={handleDialogClose}
            className={styles['button-cancel']}
          >
            Cancel
          </button>
          <button onClick={handleAddRow} className={styles['button-add']}>
            Save
          </button>
        </footer>
      </Dialog>
    </div>
  );
};

export default Sdlc;

const DialogForm = ({ table, newRow, handleInputChange, resourceTypes }) => {
  const commonFields = (
    <>
      <div className={styles['input-group']}>
        <InputField
          label="%"
          type="percentage"
          className={styles['input-field']}
          placeholder="Enter %"
          value={newRow.percentage}
          onChange={(e) => handleInputChange('percentage', e.target.value)}
        />
        <SelectField
          label="% of"
          value={newRow.percentage_of || ''}
          onChange={(e) => handleInputChange('percentage_of', e.target.value)}
          options={resourceTypes}
        />
      </div>

      <InputField
        label="Remarks"
        type="text"
        className={styles['input-field']}
        placeholder="Remarks"
        value={newRow.remarks || ''}
        onChange={(e) => handleInputChange('remarks', e.target.value)}
      />
    </>
  );

  switch (table) {
    case 'taskTable':
      return (
        <>
          <InputField
            label="Task"
            type="text"
            className={styles['input-field']}
            placeholder="Enter Task details"
            value={newRow.task || ''}
            onChange={(e) => handleInputChange('task', e.target.value)}
          />
          {commonFields}
        </>
      );

    case 'projectTable':
    case 'codeCoverageTable':
      return (
        <>
          <div className={styles['input-group']}>
            <InputField
              label="From Effort"
              type="number"
              className={styles['input-field']}
              placeholder="From"
              value={newRow.from}
              onChange={(e) => handleInputChange('from', e.target.value)}
            />
            <InputField
              label="To Effort"
              type="number"
              className={styles['input-field']}
              placeholder="To"
              value={newRow.to}
              onChange={(e) => handleInputChange('to', e.target.value)}
            />
          </div>
          {commonFields}
        </>
      );

    case 'testTable':
      return (
        <>
          <div className={styles['input-group']}>
            <SelectField
              label="Test type"
              value={newRow.type || ''}
              onChange={(e) => {
                handleInputChange('type', e.target.value);
              }}
              options={[
                { label: 'Automation', value: 'AUTOMATION' },
                { label: 'Manual', value: 'MANNUAL' },
              ]}
            />
            <SelectField
              label="type"
              value={
                newRow.is_mandatory !== undefined &&
                newRow.is_mandatory !== null
                  ? newRow.is_mandatory
                  : ''
              }
              onChange={(e) => {
                handleInputChange('is_mandatory', e.target.value);
              }}
              options={[
                { label: 'Mandatory', value: true },
                { label: 'Optional', value: false },
              ]}
            />
          </div>
          {commonFields}
        </>
      );

    default:
      return null;
  }
};

DialogForm.propTypes = {
  table: PropTypes.string.isRequired,
  newRow: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  resourceTypes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const InputField = ({ label, type = 'text', placeholder, value, onChange }) => {
  const [error, setError] = useState('');

  const validateInput = (e) => {
    const inputValue = e.target.value;
    let isValid = true;

    if (type === 'number') {
      isValid = /^\d*\.?\d{0,2}$/.test(inputValue);
      setError(isValid ? '' : 'Only numeric values allowed');
    } else if (type === 'percentage') {
      isValid = /^\d*\.?\d{0,2}$/.test(inputValue) && inputValue <= 100;
      setError(isValid ? '' : 'Please enter a numeric value less than or equal to 100');
    } else {
      isValid = inputValue.trim() !== '';
      setError(isValid ? '' : 'This field cannot be empty');
    }

    if (isValid || inputValue === '') {
      onChange(e);
    }
  };

  return (
    <div className={styles['input-container']}>
      {label && <label className={styles['input-label']}>{label}</label>}
      <input
        type={type}
        className={styles['input-field']}
        placeholder={placeholder}
        value={value}
        onChange={validateInput}
      />
      {error && <p className={styles['error-message']}>{error}</p>}
    </div>
  );
};

InputField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};

const SelectField = ({ value, onChange, options, label }) => (
  <div
    style={{
      flex: 1,
    }}
  >
    {label && <label className={styles['input-label']}>{label}</label>}

    <Select
      value={value}
      onChange={onChange}
      displayEmpty
      className={styles['select-field']}
      IconComponent={KeyboardArrowDownIcon}
      fullWidth
    >
      <MenuItem value="">Select</MenuItem>
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          className={styles.dropDown}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </div>
);

SelectField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string,
};
